import { call, put, select, takeLatest } from 'redux-saga/effects';

import { fetchOrder as actions, } from './actions';
import * as types from './types';
import { repositories, } from 'api'
import { getChartToken } from 'common/selectors';

export {
    actions,
};

const order = new repositories.order.default();

function* fetchOrder() {
    try {
        const token = yield select(getChartToken);

        const { data, } = yield call([ order, 'get', ], token);

        yield put(actions.success(data));
    } catch (error) {}
}

function* orderSaga() {
    yield takeLatest(types.FETCH_ORDER_REQUEST, fetchOrder);
}

export default orderSaga;
